export default "__VITE_ASSET__DP4Tcd0R__"